"use strict";
/**
 * v2 iteration-discipline types (spec: sdd-artifact-based-scoring-v2, FR-6/FR-7/FR-8/FR-10).
 *
 * Measures feature-iteration behaviour: how many cycles a feature went through before
 * shipping, how long it took, and how normalized those cycles are against complexity.
 * The repo-scanner produces `IterationSignal`s, aggregates them into `IterationMetrics`,
 * and the dashboard Iteration Discipline panel consumes them.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ONE_DAY_MS = exports.ITERATION_GROUPING_WINDOW_DAYS = void 0;
/**
 * Project-wide iteration-grouping window.
 *
 * AD-4: 14 days is the empirically-chosen constant. Baymax validation (FR-9) tunes this
 * against labelled data; per-team configuration is deliberately deferred until evidence
 * of team variation.
 */
exports.ITERATION_GROUPING_WINDOW_DAYS = 14;
/** Milliseconds in one day — shared utility constant. */
exports.ONE_DAY_MS = 24 * 60 * 60 * 1000;
//# sourceMappingURL=iteration.js.map